import { render } from "./addAssessmentTasksModal.vue?vue&type=template&id=67f290cc&scoped=true"
import script from "./addAssessmentTasksModal.vue?vue&type=script&lang=js"
export * from "./addAssessmentTasksModal.vue?vue&type=script&lang=js"

import "./addAssessmentTasksModal.vue?vue&type=style&index=0&id=67f290cc&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67f290cc"]])

export default __exports__